import { useCallback } from "react";

import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@shapr3d/frontend-lib";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";

import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";
import { ElementClickAction } from "../../lib/TrackingAdapter";
import Heading from "../Heading/Heading";
import Disclaimer from "../SignUp/Disclaimer/Disclaimer";

import style from "./TeamInvitationSelfServeSSOSignup.module.css";

const schema = z
  .object({
    termsAndPrivacyAccepted: z.boolean().default(false),
  })
  .refine((data) => data.termsAndPrivacyAccepted, {
    path: ["termsAndPrivacyAccepted"],
    message: "Please agree to our Terms and Privacy Policy before proceeding.",
  });

export type TeamInvitationSSOSignUpFormData = z.infer<typeof schema>;

interface TeamInvitationSelfServeSSOSignupProps {
  redirectURL: string;
}

export const TeamInvitationSelfServeSSOSignup: React.FC<TeamInvitationSelfServeSSOSignupProps> = ({
  redirectURL,
}) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<TeamInvitationSSOSignUpFormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      termsAndPrivacyAccepted: false,
    },
  });

  const tracker = useTracker();
  const { t, m } = useTranslation();

  const submit = useCallback(() => {
    window.location.replace(redirectURL);
  }, [redirectURL]);

  return (
    <div className={style.modalContainer}>
      <form className={style.form} onSubmit={handleSubmit(submit)}>
        <Heading type="h1">{t(m.SignUp.WelcomeToShapr3D)}</Heading>

        <div className={style.disclaimer}>
          <Controller
            name="termsAndPrivacyAccepted"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Disclaimer areTermsAccepted={value} handleToggleTermsAccepted={onChange} />
            )}
          />

          {errors.termsAndPrivacyAccepted && (
            <span className={style.disclaimerErrorMessage}>
              {errors.termsAndPrivacyAccepted.message}
            </span>
          )}
        </div>
        <Button
          type="submit"
          className={style.button}
          onClick={() => {
            tracker.trackButtonClick({
              action: ElementClickAction.JOIN_TEAM,
            });
          }}
        >
          {t(m.General.Continue)}
        </Button>
      </form>
    </div>
  );
};
